import { usePauseValidator } from '@ps/web-shared-components';
import type { Error, ErrorOrPromise, Errors, Validators } from '@ps/web-shared-validators';
import type { FieldValidator } from 'final-form';
import { isFunction } from 'lodash';
import { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useValidator = (...validators: Validators): [FieldValidator<any>, Errors] => {
  // TODO: Rewrite the whole thing to use observables when this issue in final-form is fixed
  // https://github.com/final-form/react-final-form/issues/346
  const [validationErrors, setValidationErrors] = useState<Errors>([]);
  const isMounted = useRef<boolean>(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const resultsRef = useRef<any>(undefined);
  const getResult = (results: Error[]) => results.find(({ valid }) => !valid);
  usePauseValidator();

  const getAsyncResult = async (asyncResults: ErrorOrPromise[]) => {
    resultsRef.current = await Promise.all<Error>(asyncResults);

    return getResult(resultsRef.current);
  };

  useEffect(() => {
    if (resultsRef.current) {
      setValidationErrors(resultsRef.current);
    }
  }, []);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    []
  );

  return [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value: any, values: any, meta: any) => {
      const allResults = validators.map(
        (callback) => callback(value, values, meta) as Promise<Error>
      );
      resultsRef.current = allResults.filter((result: Promise<Error>) => !isFunction(result.then));

      return allResults.length === resultsRef.current.length
        ? getResult(allResults as Error[])
        : getAsyncResult(allResults);
    },
    validationErrors
  ];
};

export default useValidator;
